import fetch from 'isomorphic-unfetch';

export async function trackSearchTerm(searchTerm) {
  return fetch('/api/search-analytics/trackSearchTerm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ searchTerm: searchTerm }),
  });
}
